import axiosInstance from '../common/axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

// admin referral
export async function saveReferral(data) {
  return axiosInstance.post(`${backendUrl}/api/referrals`, data);
}


// admin referral
export async function updateReferral(referralId, data) {
  return axiosInstance.put(`${backendUrl}/api/referrals/${referralId}`, data);
}


// admin referral
export async function updateReferralStatus(referralId, data) {
    
    alert(data);
  return axiosInstance.put(`${backendUrl}/api/referrals/${referralId}/status?status=${data}`);
}



// user referral
export async function saveMyReferral(data) {
  return axiosInstance.post(`${backendUrl}/api/referrals`, data);
}

// user referral
export async function getMyReferrals(userId) {
  return axiosInstance.get(`${backendUrl}/api/referrals/user/${userId}`);
}

// user referral
export async function getReferrals() {
  return axiosInstance.get(`${backendUrl}/api/referrals`);
}
// admin referral
export async function getReferralStatus() {
  return axiosInstance.get(`${backendUrl}/api/lookup-values/type/REFERRAL_STATUS`);
}
